import * as Library from "../../../utils/Library";

// #region REQUESTS
export async function uploadBuyerFileRequest({ base64Data, purpose, setLoader, onError }) {
    const res = await Library.makeApiRequest({
        endpoint: "uploadBuyerFile",
        data: {
            base64Data,
            purpose
        },
        setLoader,
        onError
    });

    if (res?.data?.status !== 200) return undefined;
    return res?.data?.data?.artifactID ?? null;
}
// #endregion
